export default __webpack_public_path__ + "static/media/products-earbuddyz2-black-comp.24611e21.png";